import React from 'react';
import {
  Chip,
  TableCell,
  TableRow,
  Typography,
} from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { useNavigate } from 'react-router-dom';

function formatPercent(value, digits = 0) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  const rounded = Number(n.toFixed(digits));
  const prefix = rounded > 0 ? '+' : '';
  return `${prefix}${rounded}%`;
}

function formatMaybeNumber(value, digits = 1) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '—';
  return n.toFixed(digits);
}

function renderTokenLabel(token) {
  if (!token) return '';
  if (token.symbol) return token.symbol;
  const address = String(token.address || '');
  if (!address) return '';
  if (address.length <= 12) return address;
  return `${address.slice(0, 6)}…${address.slice(-4)}`;
}

export default function StoryTypeRow({ row }) {
  const navigate = useNavigate();

  return (
    <TableRow hover>
      <TableCell>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Typography style={{ color: '#eef2ff', fontWeight: 700, fontSize: 14 }}>
            {row.display_name || row.story_type}
          </Typography>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
            <Chip
              size="small"
              label={row.superclass || 'Other'}
              style={{
                background: 'rgba(77, 121, 255, 0.16)',
                border: '1px solid rgba(77, 121, 255, 0.3)',
                color: '#b9ccff',
                height: 22,
              }}
            />
            <Typography style={{ color: '#7f88b3', fontSize: 11 }}>
              {row.story_type}
            </Typography>
          </div>
        </div>
      </TableCell>
      <TableCell align="right">
        <Typography style={{ color: '#eef2ff', fontWeight: 700, fontSize: 14 }}>
          {row.count}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography style={{ color: row.count_change_pct > 0 ? '#7df0a6' : row.count_change_pct < 0 ? '#ff9f9f' : '#eef2ff', fontWeight: 600, fontSize: 13 }}>
          {formatPercent(row.count_change_pct, 0)}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography style={{ color: '#dbe4ff', fontSize: 13 }}>
          {formatMaybeNumber(row.avg_score, 1)}
        </Typography>
      </TableCell>
      <TableCell>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {(row.dominant_tokens || []).map((token) => (
            <Chip
              key={`${row.story_type}_${token.address}`}
              size="small"
              label={renderTokenLabel(token)}
              onClick={() => navigate(`/token/${token.address}`)}
              onDelete={() => navigate(`/token/${token.address}`)}
              deleteIcon={<OpenInNewIcon style={{ fontSize: 14, color: '#9ec4ff' }} />}
              style={{
                background: 'rgba(255,255,255,0.06)',
                border: '1px solid rgba(158,196,255,0.22)',
                color: '#eef2ff',
                height: 22,
                cursor: 'pointer',
              }}
            />
          ))}
          {(!row.dominant_tokens || row.dominant_tokens.length === 0) && (
            <Typography style={{ color: '#7f88b3', fontSize: 12 }}>—</Typography>
          )}
        </div>
      </TableCell>
      <TableCell align="right">
        <Typography style={{ color: '#eef2ff', fontWeight: 700, fontSize: 14 }}>
          {row.derived_verdict_count}
        </Typography>
      </TableCell>
      <TableCell align="right">
        <Typography style={{ color: '#dbe4ff', fontSize: 13 }}>
          {row.derived_verdict_count >= 5 ? formatPercent((row.derived_verdict_win_rate || 0) * 100, 0) : '—'}
        </Typography>
      </TableCell>
    </TableRow>
  );
}
